import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Tiny hook that fetches the caller's wallet balance and re-fetches on the
 * `notelosh:wallet-changed` event (dispatched after top-ups, purchases and
 * cash-outs). Cheap enough to embed anywhere; no polling.
 */
export function useWallet() {
  const [wallet, setWallet] = useState(null);
  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await api.get("/wallet/me");
        if (!cancelled) setWallet(r.data);
      } catch { /* ignore — user probably not logged in */ }
    };
    load();
    const onChange = () => load();
    window.addEventListener("notelosh:wallet-changed", onChange);
    return () => {
      cancelled = true;
      window.removeEventListener("notelosh:wallet-changed", onChange);
    };
  }, []);
  return wallet;
}

export function fmtEuro(cents) {
  return `€${((cents || 0) / 100).toFixed(2)}`;
}
